// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"84d8e2c3b99f1c72f561","6980":"5a3a79cc96cd0bbee97f"}[chunkId] + ".js";
};